import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, POST, PUT } from '../../../common/contants'
import { ReponseData2 } from '../../../types'
import { ShellTType } from '../../../types/shell'
import { axiosBaseQuery } from '../../baseQuery'

export const priceBaseApi = createApi({
  reducerPath: 'priceBaseApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['PriceBase'],
  endpoints: (builder) => ({
    getListPriceBase: builder.query({
      query: (params) => ({
        url: NetWork.priceBase,
        method: GET,
        params: params,
        providesTags: (result: ReponseData2<{ rows: ShellTType[] }>) =>
          result ? [{ type: 'PriceBase', id: 'LIST' }] : []
      })
    }),
    getPriceBaseById: builder.query({
      query: (params: { priceBaseId: number }) => ({
        url: NetWork.priceBaseId(params.priceBaseId),
        method: GET
      })
    }),
    addPriceBase: builder.mutation({
      query: (data) => ({
        url: NetWork.priceBase,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'PriceBase', id: 'LIST' }]
    }),
    updatePriceBase: builder.mutation({
      query: (data) => ({
        url: NetWork.priceBaseId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'PriceBase', id: 'LIST' }]
    }),
    deletePriceBase: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.priceBase,
        method: DELETE,
        data: data
      }),
      invalidatesTags: [{ type: 'PriceBase', id: 'LIST' }]
    }),
    applyBasePrice: builder.mutation({
      query: (customerId: number) => ({
        url: NetWork.priceBaseApply(customerId),
        method: POST
      }),
      invalidatesTags: [{ type: 'PriceBase', id: 'LIST' }]
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListPriceBaseQuery,
  useDeletePriceBaseMutation,
  useAddPriceBaseMutation,
  useGetPriceBaseByIdQuery,
  useUpdatePriceBaseMutation,
  useApplyBasePriceMutation
} = priceBaseApi
